import axios from "axios";
import { toast } from "react-toastify";
import api from "../../api";

import AppleLogo from "./apple-logo.svg";
import GoogleLogo from "./google-logo.svg";
import MicrosoftLogo from "./microsoft-logo.svg";

export default function OAuthBar() {
  async function oAuthRedirect(provider: string) {
    try {
      // setLoading(true);
      const { data, status } = await api.auth.getOAuthURL(provider, "admin");
      // setLoading(false);
      if (status === 200) {
        window.open(data.result?.targetUrl, "_self");
      } else {
        toast.error("Error on OAuth redirect");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error("Something really went wrong!");
      }
    }
  }

  return (
    <div className="flex space-x-3 mt-2 mx-5">
      <button
        type="submit"
        className="w-full flex justify-center bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-100 disabled:text-gray-500"
        onClick={() => oAuthRedirect("o365-admin")}
      >
        <img className="h-5" src={MicrosoftLogo} />
      </button>
      {/* <button
        type="submit"
        className="w-full flex justify-center bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        onClick={() => oAuthRedirect("github-admin")}
      >
        <FaGithub size={20} />
      </button> */}
      <button
        type="submit"
        className="w-full flex justify-center bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        onClick={() => oAuthRedirect("google-admin")}
      >
        <img className="h-5" src={GoogleLogo} />
      </button>
      {/* <button
        type="submit"
        disabled
        className="w-full flex justify-center bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-100 disabled:text-gray-500"
        onClick={() => oAuthRedirect("facebook-admin")}
      >
        <FaFacebook size={20} />
      </button> */}
      <button
        type="submit"
        className="w-full flex justify-center bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        onClick={() => oAuthRedirect("apple-admin")}
      >
        <img className="h-5" src={AppleLogo} />
      </button>
    </div>
  );
}
